import { Box, Typography } from '@mui/material';
import { useChildTokens } from './useChildTokens';
import { formatTime, remainingFraction, TimerViewProps, TIMER_SURFACE } from './timerView';

/**
 * Stapeln — samma återstående tid som ringen, men som en krympande stapel.
 *
 * Den fyllda delen ÄR tiden som är kvar (den minskar från höger), vilket är den
 * enklaste avläsningen för ett barn som inte läser klocka. Ytan är lika hög som
 * ringens (TIMER_SURFACE) så att inget hoppar när visningsformen byts. Ren
 * renderare: tiden kommer som prop, ingen egen setInterval (se timerView.ts).
 */
const TimerBar = ({
  time,
  totalSeconds,
  label,
  color,
  onToggle,
  showDigits = true,
}: TimerViewProps) => {
  const tokens = useChildTokens();
  const remainingPercent = remainingFraction(time, totalSeconds) * 100;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2.5 }}>
      <Box
        component="button"
        type="button"
        data-testid="timer-bar"
        onClick={onToggle}
        aria-label={label}
        sx={{
          width: '100%',
          maxWidth: 280,
          height: TIMER_SURFACE,
          px: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5,
          border: 'none',
          background: 'none',
          fontFamily: 'inherit',
          cursor: onToggle ? 'pointer' : 'default',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {showDigits && (
            <Typography sx={{ fontSize: '2rem', fontWeight: 900, color: tokens.text }}>
              {formatTime(time)}
            </Typography>
          )}
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: tokens.textSoft }}>
            {label}
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100%',
            height: 32,
            borderRadius: '16px',
            bgcolor: tokens.border,
            overflow: 'hidden',
          }}
        >
          <Box
            data-testid="timer-bar-fill"
            sx={{
              width: `${remainingPercent}%`,
              height: '100%',
              borderRadius: '16px',
              bgcolor: color,
              transition: 'width 1s linear',
              '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TimerBar;
